import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Time from "common/components/time";
import { toast } from 'react-toastify';



import { copyAcademicScheduleSvc, getAcademicScheduleDetailsSvc } from "./academicScheduleSvc";

const DuplicateAcademicScheduleForm = (props) => {
    const { acdSchId, acdYrId, wngId, closeSlider, updateKey, setLoader, setOpacity } = props;

    const [originalAcdSchdId, setOriginalAcdSchdId] = useState();
    const [academicYearId, setAcademicYearId] = useState(acdYrId);
    const [sessionTypeId, setSessionTypeId] = useState(0);
    const [academicSessionLabel, setAcademicSessionLabel] = useState("");
    const [fromDt, setFromDt] = useState("");
    const [toDt, setToDt] = useState("");
    const [startHour, setStartHour] = useState("");
    const [startMinute, setStartMinute] = useState("");
    const [startAMPM, setStartAMPM] = useState("");
    const [originalStartTm, setOriginalStartTm] = useState(null);
    const [originalEndTm, setOriginalEndTm] = useState(null);
    const [originalWingId, setOriginalWingId] = useState(0);

    useEffect(() => {
        // console.log("useEffect called in acdScheduleForm");
        // console.log("academicScheduleId Received", acdSchId);
        // console.log("lstAcademicSessionType", lstAcademicSessionType);
        // console.log("academicScheduleData", academicScheduleData);
        if (acdSchId) {
            setOriginalAcdSchdId(acdSchId);
            setOriginalWingId(wngId);
            getAcademicScheduleData();
        }
    }, [acdSchId]);

    const getAcademicScheduleData = () => {
        getAcademicScheduleDetailsSvc(acdSchId, academicScheduleDataResponse);
    }

    const academicScheduleDataResponse = (data) => {
        var obj = data;
        if (obj.status === 'Success') {
            fillAcademicScheduleData(obj.academicScheduleData);
            // console.log("obj.academicScheduleData in academicScheduleDataResponse", obj.academicScheduleData)
        }
        else {
            if (obj.message == 'You are not logged in') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            }
            else if (obj.message == 'Your Session is expired, login again') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        }
        setLoader("none");
        setOpacity(1);
    }

    const fillAcademicScheduleData = (acdSchData) => {
        setOriginalWingId(acdSchData.wingId);
        setOriginalStartTm(acdSchData.startTm);
        setOriginalEndTm(acdSchData.endTm);

        // if (acdSchData.startTm && timeRegex.test(acdSchData.startTm)) {
        const [startTime, startAMPM] = acdSchData.startTm.split(' ');
        const [startHours, startMinutes] = startTime.split(':');
        setStartAMPM(startAMPM);
        setStartHour(startHours);
        setStartMinute(startMinutes);
    }


    const dmyToString = (dt) => {
        if (dt === "00-00-0000" || dt === null || dt === undefined) {
            return "";
        }
        var date = dt;
        date = date.split('-');
        var setDate = date.reverse().join();
        setDate = setDate.replace(/,/g, '-');
        var formatDt = new Date(setDate);
        return formatDt;
    }

    const handleChangeDateFormat = (dt) => {
        // console.log("handleChangeDateFormat called date received", dt);
        if (!!dt)
            var ddmmyyyy = toDMY(dt);
        var formatedDate = dmyToString(ddmmyyyy);
        // console.log("date returned", formatedDate);
        return formatedDate;
    }

    const toDMY = (dt) => {
        var tmpDd = dt.getDate();
        var dd = tmpDd < 9 ? "0" + tmpDd : tmpDd;
        var mon = dt.getMonth() + 1;
        var mm = mon < 10 ? "0" + mon : mon;
        let dmyDate = dd + "-" + mm + "-" + dt.getFullYear();
        return dmyDate;
    }

    const saveForm = () => {
        // console.log("saveForm called, academicYearId", academicYearId);

        var startTm = startHour + ":" + startMinute + " " + startAMPM;
        if (fromDt === "") {
            toast.warning("Please Fill From Date");
            return false
        }
        if (toDt === "") {
            toast.warning("Please Fill To Date");
            return false
        }
        else {
            if (startHour === "HH") {
                toast.warning('Please Select Start Hour');
                return false;
            }
            else if (startMinute === 'MM') {
                toast.warning('Please Select Start Minute');
                return false;
            }
        }


        const academicSchedule = {
            academicYearId: academicYearId,
            originalAcdSchdId: originalAcdSchdId,
            fromDt: toDMY(fromDt),
            toDt: toDMY(toDt),
            label: academicSessionLabel,
            startTm: startTm,
            originalWingId: originalWingId,
            originalStartTm: originalStartTm,
            originalEndTm: originalEndTm,
        };

        // console.log("academicSchedule", academicSchedule);
        setLoader("block");
        setOpacity(0.5);
        copyAcademicScheduleSvc(academicSchedule, saveAcademicScheduleResponse);
    }

    const saveAcademicScheduleResponse = (data) => {
        var obj = data;
        if (obj.status === 'Success') {
            toast.success(obj.message);
            updateKey();
            closeSlider();
        }
        else {
            if (obj.message == 'You are not logged in') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            }
            else if (obj.message == 'Your Session is expired, login again') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        }
        setLoader("none");
        setOpacity(1);
    }

    return (
        <div className="col-xs-12 col-centered padding-remove ">

            <div>
                <button type="button" className='btn btn-info text-center btnCloseDiv' onClick={closeSlider} style={{ right: "60%" }}>
                    <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
                </button>

            </div>
            <div className="col-xs-12 col-centered padding-remove " style={{ height: '100vh', width: '100%', background: '#fff', border: '1px solid #ccc' }}>
                <form id="addForm" className="form-horizontal formWrapper" style={{ width: '60%', borderRadius: 10, marginLeft: "20%", marginTop: "100px" }}>

                    <div className="form-group col-md-10">
                        <label className="control-label col-sm-6">
                            {" "}
                            Session Label{" "}
                            <span style={{ color: "red", marginLeft: 2 }}>*</span>
                        </label>
                        <div className="col-sm-6 padding-remove">
                            <input
                                autoComplete="off"
                                className="form-control"
                                type="text"
                                value={academicSessionLabel}
                                onChange={(e) => setAcademicSessionLabel(e.target.value)}
                                placeholder="regular"
                                required
                            />
                        </div>
                    </div>
                    <div className="form-group col-md-10">
                        <label className="control-label col-sm-6">
                            From Date<span style={{ color: "red", marginLeft: 2 }}>*</span>
                        </label>
                        <div className="col-sm-6 padding-remove">
                            <DatePicker id="fromDt"
                                className='form-control'
                                placeholderText="Enter From Date"
                                selected={fromDt}
                                onChange={(dt) => setFromDt(handleChangeDateFormat(dt))}
                                dateFormat="dd-MM-yyyy"
                                dropdownMode="select"
                                autoComplete='off'
                                showMonthDropdown
                                showYearDropdown
                                adjustDateOnChange
                            />
                        </div>
                    </div>
                    <div className="form-group col-md-10">
                        <label className="control-label col-sm-6">
                            To Date<span style={{ color: "red", marginLeft: 2 }}>*</span>
                        </label>
                        <div className="col-sm-6 padding-remove">
                            <DatePicker id="fromDt"
                                className='form-control'
                                placeholderText="Enter From Date"
                                selected={toDt}
                                onChange={(dt) => setToDt(handleChangeDateFormat(dt))}
                                dateFormat="dd-MM-yyyy"
                                dropdownMode="select"
                                autoComplete='off'
                                showMonthDropdown
                                showYearDropdown
                                adjustDateOnChange
                            />
                        </div>
                    </div>
                    <div className="form-group col-md-10 startTime ">
                        <Time label={"Start Time"}
                            hour={startHour} setHour={setStartHour}
                            minutes={startMinute} setMinutes={setStartMinute}
                            ampm={startAMPM} setAMPM={setStartAMPM}
                        // disabled={sessionTypeId == 30? true : false}
                        />
                    </div>
                    <div className="form-group">
                        <div className="col-sm-10 text-right">
                            <button
                                type="button"
                                style={{ marginTop: 20 }}
                                onClick={() => saveForm()}
                                className="btn btn-success"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default DuplicateAcademicScheduleForm;
